import { render, staticRenderFns } from "./LegoViewInModalTarjeta.vue?vue&type=template&id=d03ec746&scoped=true"
import script from "./LegoViewInModalTarjeta.vue?vue&type=script&lang=js"
export * from "./LegoViewInModalTarjeta.vue?vue&type=script&lang=js"
import style0 from "./LegoViewInModalTarjeta.vue?vue&type=style&index=0&id=d03ec746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03ec746",
  null
  
)

export default component.exports